// src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Providers de contexto
import { AuthProvider } from './context/AuthContext';
import { PermisosProvider } from './context/PermisosContext';

/**
 * Runtime config opcional (sin tocar public/index.html):
 * Si no viene por window.__ENV__ ni por REACT_APP_FIRMWARE_BASE,
 * usamos "/Firmware" (carpeta estática del frontend en IIS).
 */
window.__ENV__ = window.__ENV__ || {};
if (!window.__ENV__.FIRMWARE_BASE) {
  window.__ENV__.FIRMWARE_BASE = process.env.REACT_APP_FIRMWARE_BASE || "/Firmware";
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <PermisosProvider>
        <App />
      </PermisosProvider>
    </AuthProvider>
  </BrowserRouter>
);
